type PageTitleInput = {
	siteName: string;
	title?: string;
	tabName?: string;
	categorySlug?: string;
	guidelineCategory?: string;
	parentPageTitle?: string;
	subpageTabName?: string;
};

/**
 * Formats document titles from the page hierarchy and site name.
 */
export const formatPageTitle = ({
	title,
	tabName,
	categorySlug,
	guidelineCategory,
	parentPageTitle,
	subpageTabName,
	siteName,
}: PageTitleInput): string => {
	if (guidelineCategory === 'Components' && !categorySlug && !subpageTabName) {
		return `${title} - ${tabName} - Components - ${siteName}`;
	}
	if (!categorySlug && subpageTabName) {
		return `${title} - ${subpageTabName} - Components - ${siteName}`;
	}
	if (guidelineCategory && parentPageTitle) {
		return `${parentPageTitle} - ${title} - ${guidelineCategory} - ${siteName}`;
	}
	if (categorySlug) {
		return `Overview - ${categorySlug} - ${siteName}`;
	}
	if (guidelineCategory && !subpageTabName) {
		return `${title} - ${guidelineCategory} - ${siteName}`;
	}
	if (title) {
		return `${title} - ${siteName}`;
	}
	return siteName;
};
